var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.8334H3.33333C2.89131 16.8334 2.46738 16.6578 2.15482 16.3452C1.84226 16.0326 1.66667 15.6087 1.66667 15.1667V4.33335H0V2.66669H3.33333V1.83335C3.33333 1.39133 3.50893 0.967403 3.82149 0.654842C4.13405 0.342282 4.55797 0.166687 5 0.166687H10C10.442 0.166687 10.8659 0.342282 11.1785 0.654842C11.4911 0.967403 11.6667 1.39133 11.6667 1.83335V2.66669H15V4.33335H13.3333V15.1667C13.3333 15.6087 13.1577 16.0326 12.8452 16.3452C12.5326 16.6578 12.1087 16.8334 11.6667 16.8334ZM3.33333 4.33335V15.1667H11.6667V4.33335H3.33333ZM5 1.83335V2.66669H10V1.83335H5ZM10 13.5H8.33333V6.00002H10V13.5ZM6.66667 13.5H5V6.00002H6.66667V13.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1f8f9d5b05cfae4d74d79d17116cf882.svg";
export { ForwardRef as ReactComponent };